import DataTable from "@shared/ui/data-table/DataTable";
import SearchTable from "@shared/ui/search-table/SearchTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledOutcomes } from "./outcomes.styled";
import { SEARCH_TABLE_STYLE } from "./outcomes.constants";
import { useOutcomeOptions } from "./outcomes.data";
import { useOutcomeStructures } from "./useOutcomeStructures";
import { useOutcomesBrowse } from "./useOutcomesBrowse";
import { useOutcomesNavigation } from "./useOutcomesNavigation";

function Outcomes() {
  const theme = useTheme();
  const { searchStructure, tableStructure } = useOutcomeStructures();
  const browse = useOutcomesBrowse();
  const navigation = useOutcomesNavigation();
  const outcomeOptions = useOutcomeOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledOutcomes>
      {searchStructure ? (
        <SearchTable
          structure={searchStructure}
          useForm={browse.accountSearchForm}
          setStructure={navigation.editSearchStructure}
          reset={browse.reset}
          style={SEARCH_TABLE_STYLE}
        />
      ) : (
        <Skeleton variant="rectangular" height={100} animation="wave" sx={skeletonSx} />
      )}
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={outcomeOptions}
          pagination={{
            page: browse.page,
            perPage: browse.perPage,
            hasNextPage: browse.hasNextPage,
            hasPrevPage: browse.hasPrevPage,
            onNextPage: browse.handleNextPage,
            onPrevPage: browse.handlePrevPage,
            onRowsPerPageChange: browse.handleRowsPerPageChange,
          }}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledOutcomes>
  );
}

export default Outcomes;
